import React from 'react';
import { useObservable } from 'react-use-observable';

import { Button, Modal, Spin, Typography } from 'antd';

import { partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { Icon } from '@eduzz/ui-antd-theme';

import { Table } from './Table';

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const DetailsModal = ({ isOpen, handleClose }: IProps) => {
  const [details] = useObservable(() => partnerCommissionsService.getPartnerCommissionsDetails(), []);
  const [loadingPartnerCommissionsDetails] = useObservable(
    () => partnerCommissionsService.getLoadingPartnerCommissionsDetails(),
    []
  );

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      width={670}
      title='Mais detalhes'
      footer={
        <div className='flex justify-end'>
          <Button type='text' onClick={handleClose}>
            Fechar
          </Button>
        </div>
      }
    >
      {loadingPartnerCommissionsDetails && (
        <div className='flex items-center justify-center p-8'>
          <Spin size='large' />
        </div>
      )}
      {!loadingPartnerCommissionsDetails && (
        <div className='flex max-h-130 flex-col gap-4 overflow-y-auto'>
          <div className='rounded-(--uizz-antd-border-radius-lg) bg-(--uizz-antd-color-fill-tertiary) p-3'>
            <div className='flex items-center gap-2'>
              <Icon.User />
              <Typography.Text strong>
                Parceiro (Coprodutor): <Typography.Text type='secondary'>{details?.commissioned_name}</Typography.Text>
              </Typography.Text>
            </div>
          </div>

          <Table commissions={details?.commissions || []} />
        </div>
      )}
    </Modal>
  );
};
